var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJsu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.52 0c14.28 7.65 28.58 15.24 42.83 22.94 127.83 69.41 238.84 160.12 330.32 273.42-383.35-140.6-714.14 236.42-405.41 363.71C318.59 708.42 108 679 7.75 529.54c-7.16-11.42-7.61-20.4-1.3-32.73Q173 171.71 498.52 6.62c3.6-1.82 8.3-2.24 10.34-6.62z",
    fill: "#0265fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138 729.6c148.67 50.64 317.61 38.65 443-62.17C694.38 587.12 687.85 393.72 536.31 365c158.36-49.26 358.89-24.25 467.05 111.38 24 32.21 23.78 33.18 5.16 68.76a1091.27 1091.27 0 01-214.69 285.3A1087.23 1087.23 0 01520 1021.64c-5.81 2.85-10.21 3.29-16.11.37C361.81 950.7 236.05 854.9 138 729.6z",
    fill: "#caa633"
  })));
}
export default SvgJsu;